function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.2166 11.5365C17.0217 10.3932 17.5 9.00487 17.5 7.49982C17.5 3.63812 14.3617 0.499817 10.5 0.499817C6.63831 0.499817 3.50002 3.63812 3.50002 7.49982C3.50002 9.00492 3.97834 10.3932 4.78342 11.5365C2.21682 13.2049 0.420115 15.9699 0.0701149 19.1665C0.0232399 19.5515 0 19.9364 0 20.3331C0 20.9747 0.525 21.4997 1.1666 21.4997H10.5001V19.1663H2.4271C2.75386 16.8446 4.0605 14.7913 6.0554 13.4963L8.0855 12.178L6.6972 10.1946C6.1253 9.40142 5.8337 8.46802 5.8337 7.49967C5.8337 4.92137 7.922 2.83307 10.5003 2.83307C13.0786 2.83307 15.1669 4.92137 15.1669 7.49967C15.1669 8.46802 14.8753 9.40142 14.3036 10.1946L12.9153 12.178L14.6885 13.3331H18.3168C17.6985 12.6446 16.9869 12.0497 16.2168 11.5364L16.2166 11.5365ZM24.5001 15.6664V17.9998H15.1666V15.6664H24.5001ZM24.5001 19.1664V21.4998H15.1666V19.1664H24.5001ZM24.5001 22.6664V24.9998H15.1666V22.6664H24.5001Z",
  fill: "white"
});

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.9246e642.svg";
export { ForwardRef as ReactComponent };